import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["width"]
const _hoisted_2 = ["width"]
const _hoisted_3 = {
  key: 0,
  class: "mb-2 px-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "oss-dense-table",
  width: "100%"
}
const _hoisted_10 = {
  style: {"text-align":"center"},
  width: "45%"
}
const _hoisted_11 = ["width"]
const _hoisted_12 = ["width"]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = ["width"]
const _hoisted_15 = { class: "d-flex justify-space-around align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      width: _ctx.onAccountingLinesPage && '20%'
    }, [
      _createVNode(_component_AccountableAccount, {
        modelValue: _ctx.accountableAccount,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountableAccount) = $event)),
        inAccountableAccounts: _ctx.accountableAccounts,
        thirdParty: _ctx.line.thirdPartyCompany || _ctx.line.user || _ctx.line.bankAccount,
        "show-validation": false,
        "hide-details": true,
        outlined: "",
        "company-id": _ctx.company.id,
        "edit-sub-accountable-account": false,
        label: "Compte comptable",
        editAccountableAccount: true,
        embeddedInput: true,
        defineThirdParty: true,
        readonly: _ctx.readonly,
        disabled: _ctx.line.isBankTransaction || !!_ctx.line.tag,
        addInvoiceProduct: _ctx.enableStock,
        tabindex: !_ctx.onAccountingLinesPage && _ctx.TAB_INDEX_OFFSET * _ctx.index + 2,
        id: 'line-aa-' + _ctx.index,
        showDescription: "true",
        ref: "accountableAccount",
        onAccountingLinesPage: _ctx.onAccountingLinesPage,
        onFocusOnDateOrWording: _ctx.focusOnDateOrWording
      }, {
        activator: _withCtx(({ props, accountableAccountName }) => [
          _createVNode(_component_v_text_field, _mergeProps({
            "hide-details": "",
            readonly: "",
            "data-cy": 'accountingItemEdition-item-' + _ctx.index + '-accountableAccount'
          }, props, {
            "onUpdate:focused": ($event: any) => (_ctx.onAAFocus($event, props.onClick)),
            tabindex: 
                            _ctx.onAccountingLinesPage
                                ? (_ctx.editionIndex + 1) * 100 + (_ctx.index + 1) * 10 + 1
                                : _ctx.TAB_INDEX_OFFSET * _ctx.index + 1
                        ,
            "model-value": accountableAccountName
          }), null, 16, ["data-cy", "onUpdate:focused", "tabindex", "model-value"])
        ]),
        _: 1
      }, 8, ["modelValue", "inAccountableAccounts", "thirdParty", "company-id", "readonly", "disabled", "addInvoiceProduct", "tabindex", "id", "onAccountingLinesPage", "onFocusOnDateOrWording"])
    ], 8, _hoisted_1),
    _createElementVNode("td", {
      width: _ctx.onAccountingLinesPage && '20%'
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_v_text_field, {
          modelValue: _ctx.line.wording,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.line.wording) = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onItemWordingChanged())),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFocus('wording'))),
          "hide-details": "",
          outlined: "",
          placeholder: _ctx.defaultWording,
          readonly: _ctx.readonly || !!_ctx.line.tag,
          prefixDataCy: 'AccountingItemEdition-item-' + _ctx.index,
          tabindex: 
                        _ctx.onAccountingLinesPage
                            ? (_ctx.editionIndex + 1) * 100 + (_ctx.index + 1) * 10 + 3
                            : _ctx.TAB_INDEX_OFFSET * _ctx.index + 2
                    ,
          density: "compact"
        }, null, 8, ["modelValue", "placeholder", "readonly", "prefixDataCy", "tabindex"])
      ]),
      (_ctx.displayFreeTag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_FreeTag, {
              inPrimaryLog: 'XXXXXX',
              companyTags: _ctx.companyTags,
              company: _ctx.company,
              documentType: _ctx.type,
              accountingLine: _ctx.line,
              onOnTagsChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onAccountingLineTagsChanged($event)))
            }, null, 8, ["companyTags", "company", "documentType", "accountingLine"])
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    (_ctx.addQuantityColumn)
      ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
          (_ctx.line.stockOperation && _ctx.line.stockOperation.stockProduct)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.line.stockOperation.stockProduct.title), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.addQuantityColumn)
      ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
          (_ctx.line.stockOperation && _ctx.line.stockOperation.stockProduct)
            ? (_openBlock(), _createBlock(_component_oss_text_field, {
                key: 0,
                "hide-details": true,
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFocus('productQuantity'))),
                "single-line": "",
                dense: "",
                outlined: "",
                readonly: _ctx.readonly,
                rules: [(v) => v > 0 || _ctx.$t('settings.positiveNumber')],
                "data-cy": 'AccountingItemEdition-item-' + _ctx.index + '-productQuantity',
                modelValue: _ctx.line.stockOperation.productQuantity,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.line.stockOperation.productQuantity) = $event))
              }, null, 8, ["readonly", "rules", "data-cy", "modelValue"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.additionalQuantityColumns)
      ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
          (_ctx.hasQuantities)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_v_menu, {
                  "close-on-content-click": false,
                  "offset-x": "",
                  left: ""
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, props), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.line.stockOperation.data.quantities.length) + " ", 1),
                        _createVNode(_component_v_icon, {
                          size: "x-small",
                          right: ""
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode(" $oss-edit ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, { class: "px-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("table", _hoisted_9, [
                          _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                style: {"text-align":"center"},
                                width: "45%"
                              }, "Produit"),
                              _createElementVNode("th", {
                                style: {"text-align":"center"},
                                width: "55%"
                              }, "Quantité")
                            ])
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.line.stockOperation.data.quantities, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_10, _toDisplayString(item.quantityName), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_oss_text_field, {
                                  "hide-details": true,
                                  onFocus: ($event: any) => (_ctx.onFocus('productQuantity' + index)),
                                  "single-line": "",
                                  dense: "",
                                  outlined: "",
                                  readonly: _ctx.readonly,
                                  rules: [(v) => v > 0 || _ctx.$t('settings.positiveNumber')],
                                  "data-cy": 
                                            'AccountingItemEdition-item-' +
                                            index +
                                            '-productQuantity' +
                                            index
                                        ,
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (console.log(_ctx.line.stockOperation))),
                                  modelValue: item.quantity,
                                  "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event)
                                }, null, 8, ["onFocus", "readonly", "rules", "data-cy", "modelValue", "onUpdate:modelValue"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", {
      width: _ctx.onAccountingLinesPage && '20%'
    }, [
      _createVNode(_component_oss_text_field, {
        "hide-details": true,
        onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onFocus('debit'))),
        suffix: "€",
        "onUpdate:modelValue": [
          _ctx.onItemDebitChanged,
          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.line.debit) = $event))
        ],
        "single-line": "",
        dense: "",
        outlined: "",
        readonly: _ctx.readonly,
        rules: [
                    (v) => (v !== '' && parseFloat(v) >= 0.0) || _ctx.$t('settings.positiveNumber'),
                ],
        disabled: _ctx.line.isBankTransaction || !!_ctx.line.tag,
        "data-cy": 'AccountingItemEdition-item-' + _ctx.index + '-debit',
        tabindex: 
                    _ctx.onAccountingLinesPage
                        ? (_ctx.editionIndex + 1) * 100 + (_ctx.index + 1) * 10 + 3
                        : _ctx.TAB_INDEX_OFFSET * _ctx.index + 3
                ,
        ref: "debit",
        modelValue: _ctx.line.debit
      }, null, 8, ["onUpdate:modelValue", "readonly", "rules", "disabled", "data-cy", "tabindex", "modelValue"])
    ], 8, _hoisted_11),
    _createElementVNode("td", {
      width: _ctx.onAccountingLinesPage && '20%'
    }, [
      _createVNode(_component_oss_text_field, {
        "hide-details": true,
        onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onFocus('credit'))),
        suffix: "€",
        "onUpdate:modelValue": [
          _ctx.onItemCreditChanged,
          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.line.credit) = $event))
        ],
        "single-line": "",
        dense: "",
        outlined: "",
        readonly: _ctx.readonly,
        rules: [
                    (v) => (v !== '' && parseFloat(v) >= 0.0) || _ctx.$t('settings.positiveNumber'),
                ],
        disabled: _ctx.line.isBankTransaction || !!_ctx.line.tag,
        "data-cy": 'AccountingItemEdition-item-' + _ctx.index + '-credit',
        tabindex: 
                    _ctx.onAccountingLinesPage
                        ? (_ctx.editionIndex + 1) * 100 + (_ctx.index + 1) * 10 + 4
                        : _ctx.TAB_INDEX_OFFSET * _ctx.index + 4
                ,
        onTab: _ctx.onTabOnCredit,
        ref: "credit",
        modelValue: _ctx.line.credit
      }, null, 8, ["onUpdate:modelValue", "readonly", "rules", "disabled", "data-cy", "tabindex", "onTab", "modelValue"])
    ], 8, _hoisted_12),
    (_ctx.showDueDateColumn && !_ctx.onAccountingLinesPage)
      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
          (!!_ctx.line.paymentStatus)
            ? (_openBlock(), _createBlock(_component_oss_date_picker, {
                key: 0,
                modelValue: _ctx.line.dueDate,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.line.dueDate) = $event)),
                onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onFocus('dueDate'))),
                "hide-details": "",
                textFieldClass: _ctx.onAccountingLinesPage ? 'oss-light' : 'oss-dark',
                textFieldReadOnly: false,
                disabled: _ctx.line.isBankTransaction || !!_ctx.line.tag,
                notRequired: true,
                "no-menu": true,
                outlined: false,
                "data-cy": 'accountingItemEdition-item-' + _ctx.index + '-dueDate',
                tabindex: !_ctx.onAccountingLinesPage && _ctx.TAB_INDEX_OFFSET * _ctx.index + 5
              }, null, 8, ["modelValue", "textFieldClass", "disabled", "data-cy", "tabindex"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", {
      align: "center",
      width: _ctx.onAccountingLinesPage && '20%'
    }, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn_icon, {
            icon: "$add",
            size: "small",
            onClick: _ctx.insertLineAfter,
            onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onFocus('addLine'))),
            tabindex: _ctx.TAB_INDEX_OFFSET * _ctx.index + 5,
            "data-cy": "Line-add"
          }, null, 8, ["onClick", "tabindex"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn_icon, {
            icon: "$label_outline",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.displayFreeTag = !_ctx.displayFreeTag)),
            onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onFocus('freeTag'))),
            size: "small"
          })
        ]),
        _createVNode(_component_v_btn_trash, {
          onClick: _ctx.removeLine,
          onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onFocus('removeLine'))),
          tabindex: !_ctx.onAccountingLinesPage && _ctx.TAB_INDEX_OFFSET * _ctx.index + 6,
          size: "small",
          disabled: _ctx.disabledTrash
        }, null, 8, ["onClick", "tabindex", "disabled"])
      ])
    ], 8, _hoisted_14)
  ]))
}